// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"Cj-z","zenCrossSiteLabel":"Dj-z","vrsnlCrossSiteLabel":"Ej-z"};